import { Component, NgZone, OnInit } from '@angular/core';
import { environment } from '../../../environments/environment';
import {  Router } from '@angular/router';
import { AuthenticationService } from '../../services/authentication/authentication.service';
import { SpinnerService } from '../../services/spinner/spinner.service';

declare let google: any;

@Component({
  selector: 'app-googlelogin',
  templateUrl: './googlelogin.component.html',
  styleUrls: ['./googlelogin.component.scss']
})
export class GoogleLoginComponent implements OnInit {

  returnUrl: string;
  error = '';
  isVisibleError = false;


  constructor(
    private spinnerService: SpinnerService,
    private authenticationService: AuthenticationService,
    private router: Router,
    private zone: NgZone
  ) {
    this.isVisibleError = false;
    // redirect to home if already logged in
    if (this.authenticationService.currentUserValue) {
      this.router.navigate(['/home']);
    }
    this.spinnerService.hide();
  }

  ngOnInit() {
    this.initializeGoogleLogin();
  }


  initializeGoogleLogin() {
    google.accounts.id.initialize({
      client_id: environment.clientId,
      callback: this.handleCredentialResponse.bind(Response, this)
    });
    google.accounts.id.renderButton(
      document.getElementById("googleBtn"),
      { theme: "outline", size: "medium", width: 200 }  // customization attributes
    );
  }

  handleCredentialResponse(_self: this, response: any) {
    _self.isVisibleError = false;
    _self.spinnerService.show();
    if (response !== undefined) {
      let base64Url = response.credential.split('.')[1];
      let base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      let jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      }).join(''));

      _self.authenticationService.getGoogleData(JSON.parse(jsonPayload), response.credential)
        .then(
          (data) => {
            _self.authenticationService.loginBackend(response.credential).subscribe(
              (resp) => {
                if (resp != undefined) {
                  _self.returnUrl = '/home';
                  _self.spinnerService.hide();

                  _self.zone.run(() => {
                    _self.router.navigate([_self.returnUrl]);
                  })
                }
                else {
                  _self.spinnerService.hide();
                  _self.error = "Utente non autorizzato!";
                  _self.isVisibleError = true;
                }
              }
            )
          }
        )
    }
    else {
      _self.spinnerService.hide();
      _self.error = "Utente non autorizzato!";
      _self.isVisibleError = true;
    }
  }

}
